import { ShowSiteGantnerConfig, SitesApi, UpdateSiteGantnerConfig } from '@trybeapp/sdk'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new SitesApi(apiConfiguration)

export const useGetGantnerConfig = (options?: UseQueryOptions<ShowSiteGantnerConfig>) => {
  const siteId = useCurrentSiteId()

  return useQuery<ShowSiteGantnerConfig>(
    ['gantnerConfig', siteId],
    async () => await api.getSiteGantnerConfig({ siteId }),
    options
  )
}

export const useUpdateGantnerConfig = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({
      siteId,
      updateSiteGantnerConfig,
    }: {
      siteId: string
      updateSiteGantnerConfig: UpdateSiteGantnerConfig
    }) => api.updateSiteGantnerConfig({ siteId, updateSiteGantnerConfig }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('gantnerConfig')
      },
    }
  )
}
